/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_To_Play_What_TitleInputs */

const bn_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলা কি`)
};

const de_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das Spiel?`)
};

const el_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι είναι το παιχνίδι`)
};

const en_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the game is`)
};

const es_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cual es el juego`)
};

const fr_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le principe du jeu`)
};

const hi_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खेल क्या है`)
};

const hu_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi a játék`)
};

const id_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa permainannya`)
};

const it_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è il gioco`)
};

const ja_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームとは何ですか`)
};

const ko_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임이 무엇인가요?`)
};

const nl_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat het spel is`)
};

const pl_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaka jest gra`)
};

const pt_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é o jogo`)
};

const ru_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что это за игра`)
};

const sv_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad spelet är`)
};

const tr_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun nedir`)
};

const uk_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Що таке гра`)
};

const vi_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trò chơi là gì`)
};

const zh_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游戏是什么`)
};

const zh_hant_how_to_play_what_title = /** @type {(inputs: How_To_Play_What_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊戲是什麼`)
};

/**
* | output |
* | --- |
* | "What the game is" |
*
* @param {How_To_Play_What_TitleInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const how_to_play_what_title = /** @type {((inputs?: How_To_Play_What_TitleInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_To_Play_What_TitleInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_how_to_play_what_title(inputs)
	if (locale === "de") return de_how_to_play_what_title(inputs)
	if (locale === "el") return el_how_to_play_what_title(inputs)
	if (locale === "en") return en_how_to_play_what_title(inputs)
	if (locale === "es") return es_how_to_play_what_title(inputs)
	if (locale === "fr") return fr_how_to_play_what_title(inputs)
	if (locale === "hi") return hi_how_to_play_what_title(inputs)
	if (locale === "hu") return hu_how_to_play_what_title(inputs)
	if (locale === "id") return id_how_to_play_what_title(inputs)
	if (locale === "it") return it_how_to_play_what_title(inputs)
	if (locale === "ja") return ja_how_to_play_what_title(inputs)
	if (locale === "ko") return ko_how_to_play_what_title(inputs)
	if (locale === "nl") return nl_how_to_play_what_title(inputs)
	if (locale === "pl") return pl_how_to_play_what_title(inputs)
	if (locale === "pt") return pt_how_to_play_what_title(inputs)
	if (locale === "ru") return ru_how_to_play_what_title(inputs)
	if (locale === "sv") return sv_how_to_play_what_title(inputs)
	if (locale === "tr") return tr_how_to_play_what_title(inputs)
	if (locale === "uk") return uk_how_to_play_what_title(inputs)
	if (locale === "vi") return vi_how_to_play_what_title(inputs)
	if (locale === "zh") return zh_how_to_play_what_title(inputs)
	return zh_hant_how_to_play_what_title(inputs)
});